import { useContext } from 'react';
import { ThemeContext } from './theme-provider';
export var useTheme = function useTheme() {
  return useContext(ThemeContext);
};